import { render, staticRenderFns } from "./list-modules.vue?vue&type=template&id=fbbdc0aa&scoped=true"
import script from "./list-modules.vue?vue&type=script&lang=js"
export * from "./list-modules.vue?vue&type=script&lang=js"
import style0 from "./list-modules.vue?vue&type=style&index=0&id=fbbdc0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbdc0aa",
  null
  
)

export default component.exports